// 運営画面(No.12〜16)共通の表示ヘルパ。

import {
  CASE_STATUS_LABELS,
  INVOICE_STATUS_LABELS,
  CREDIT_ENTRY_LABELS,
  type CaseStatus,
  type InvoiceStatus,
  type CreditEntryType,
} from "../../../shared/constants";

// 円表記(税込総額。免税事業者のため消費税区分なし)。
export function yen(amount: number): string {
  return `¥${amount.toLocaleString("ja-JP")}`;
}

// クレジット表記(符号付き)。
export function creditSigned(delta: number): string {
  const sign = delta > 0 ? "+" : "";
  return `${sign}${delta.toLocaleString("ja-JP")}`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const CASE_PILL: Record<string, string> = {
  intake: "pill-gray",
  knowledge_ready: "pill-blue",
  strategy_ready: "pill-purple",
  page_plan_ready: "pill-amber",
  approved: "pill-purple",
  awaiting_payment: "pill-red",
  in_production: "pill-blue",
  published: "pill-green",
  improving: "pill-green",
};

export function CaseStatusPill({ status }: { status: string }) {
  const label = CASE_STATUS_LABELS[status as CaseStatus] ?? status;
  const cls = CASE_PILL[status] ?? "pill-gray";
  return <span className={`pill ${cls}`}>{label}</span>;
}

const INVOICE_PILL: Record<string, string> = {
  unpaid: "pill-red",
  paid: "pill-green",
  canceled: "pill-gray",
};

export function InvoiceStatusPill({ status }: { status: string }) {
  const label = INVOICE_STATUS_LABELS[status as InvoiceStatus] ?? status;
  const cls = INVOICE_PILL[status] ?? "pill-gray";
  return <span className={`pill ${cls}`}>{label}</span>;
}

const ENTRY_PILL: Record<string, string> = {
  grant: "pill-green",
  consume: "pill-red",
  adjust: "pill-amber",
  expire: "pill-gray",
};

export function CreditEntryPill({ type }: { type: string }) {
  const label = CREDIT_ENTRY_LABELS[type as CreditEntryType] ?? type;
  const cls = ENTRY_PILL[type] ?? "pill-gray";
  return <span className={`pill ${cls}`}>{label}</span>;
}

export function personName(
  last: string | null | undefined,
  first: string | null | undefined,
  fallback = "—",
): string {
  const name = [last, first].filter(Boolean).join(" ").trim();
  return name || fallback;
}
